const { connect } = require('react-redux');
const { context } = require('app-context');
const Signup = require('../components/Signup');
const { push: Push } = require('connected-react-router');
const { getSignupPrefillEmail } = require('services/auth-management/signup-state');

const selectors = context.selectors.all;
const actions   = context.actions;

module.exports = connect(
    (state) => ({
        schools: selectors.getVisibleSchools(state),
        signupDetails: selectors.getSignupIdentifyDetails(state),
        rememberedEmail: getSignupPrefillEmail({
            identifyContext: selectors.getSignupIdentifyDetails(state),
            signupContext: selectors.getSignupContext(state),
            loginContext: selectors.getLoginContext(state)
        }),
        showSchoolList: true,
        text: 'Life is better when you\'re part of the community',
        secondaryText: 'Sign up with a preapproved email:',
        logo: null
    }), {
        onSubmit: actions.signup.identify.complete,
        onInvalidSubmit: actions.signup.identify.failure,
        updateLoginContext: actions.auth.updateLoginContext,
        updateSignupContext: actions.signup.updateContext,
        push: Push
    }
)(Signup);
